import {connect} from "react-redux";
import UserSettings from "./UserSettings";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {WithAppendHeaderAndFooterHOC} from "../../HOC/WithAppendHeaderAndFooterHOC";
import {WithAppendSidebarHOC} from "../../HOC/WithAppendSidebarHOC";
import {logoutUser, saveUser, sendUserConfirmation, updatedPass} from "../../globalState/user/actions";
import {getMessengersList} from "../../globalState/app/actions";
import {getMessengersListSelector} from "../../globalState/app/selectros";
import {WithSavingSnackBar} from "../../HOC/WithSavingSnackBar";


let mapStateToProps = (state) => {
    return {
        user: state.user,
        messengers: getMessengersListSelector(state),
    }
};

let mapDispatchToProps = (dispatch) => {
    return {}
};

export default compose(connect(mapStateToProps, {
    mapDispatchToProps,
    saveUser,
    getMessengersList,
    sendUserConfirmation,
    updatedPass,
}), withRouter, WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC, WithSavingSnackBar)(UserSettings);




